export default {
    counterfactual_1: 'Attributable to antibiotic resistance',
    counterfactual_2: 'Associated with antibiotic resistance',
    counterfactual_3: 'Both',
    counterfactual_4: 'Pathogens not assessed for resistance',
    counterfactual_5: 'Bacteria susceptible to antibiotics',
    counterfactual_6: 'Total',
};
